<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->

<div class="top-actions" id="top-actions">

    <div class="terminal-details">
        <label class="data-na" *ngIf="tab && tab.subTypeDetail[tab.subType.toLowerCase()]?.status !== 'loaded' || !summary"> NA </label>
        <label *ngIf="tab && tab.subTypeDetail[tab.subType.toLowerCase()]?.status === 'loaded' && summary" title="{{summary?.city}} , {{summary?.stateCode}} ({{summary?.milepost}})">{{summary && summary.city ? summary.city : '-'}} , {{summary && summary.stateCode ? summary.stateCode : '-'}} ({{summary && summary.milepost ? summary.milepost: '-'}})</label>
        <div *ngIf="tab && tab.subTypeDetail[tab.subType.toLowerCase()]?.status === 'loaded' && summary">
            <!-- <p><span>Div:</span> {{summary && summary.divisionName ? summary.divisionName : '-'}}</p>
            <p><span>Subdiv:</span>{{summary && summary.subDivision ? summary.subDivision : '-'}}</p> -->
            <p title="{{summary && summary.oprZoneName ? summary.oprZoneName : '-'}} {{summary && summary.oprSubZoneName ? summary.oprSubZoneName : '-'}}"><span>OprZone:</span> {{summary && summary.oprZoneName ? summary.oprZoneName : '-'}} <br/><span>OprSubzone:</span> {{summary && summary.oprSubZoneName ? summary.oprSubZoneName : '-'}}</p>
        </div>
    </div>

    <lms-header-sub-types [subTypes]="subTypes" [tab]="tab" [tabIndex]='tabLevel'></lms-header-sub-types>
    <div class="pdf-icon">
        <span></span>
        <input type="button" tabindex="{{tabLevel + 8}}" value="Download" (click)='downloadExcel()' class="p-button-secondary pull-right">
    </div>
    <div class="handling-search">
        <input type="text" tabindex="{{tabLevel + 5}}" spellcheck="false" id="thpSearchTextBox" placeholder="Search" [(ngModel)]="thpSearchText" #input (input)="input.value=$event.target.value.toUpperCase()" (focus)='setPageMode();' (blur)='resetPageMode();'
        />
        <button id="thpHandlingSearchBtn" tabindex="{{tabLevel + 7}}" type="button" (click)="updateTerminalHandlingSearch()">
      <i [attr.class]="'fa fa-search'"></i>
    </button>
        <button id="thpClearBtn" tabindex="{{tabLevel + 7}}" *ngIf="thpSearchText" type="button" (click)="clearTerminalHandlingSearch()">
      <i [attr.class]="'fa fa-times'"></i>
    </button>
    </div>

</div>